import React, { PureComponent } from 'react';
import { Form } from 'react-final-form';
import { updatePassword } from '../../../api/users';
import Loader from '../../../atoms/Loader';
import { isPasswordValid } from '../../../utils/validation';
import PasswordField from '../../../components/Form/PasswordField';

export default class ChangeUserPassword extends PureComponent {
  state = {
    loading: false,
  };

  handleSubmit = async (data) => {
    this.setState({
      loading: true,
    });

    updatePassword(this.props.id, data.password)
      .then(data => {
        this.setState({
          social: data,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  render() {
    return (
      <>
        <Form
          onSubmit={this.handleSubmit}
          validate={(values) => {
            const errors = {};

            if (values.password_confirm !== values.password) {
              errors.password_confirm = 'Le due password non corrispondono';
            }

            return errors;
          }}
          render={({
            handleSubmit, submitting, pristine, errors, values,
          }) => (
            <>
              <div className="columns">
                <div className="column is-half">
                  <PasswordField
                    name="password"
                    placeholder="Password"
                    validate={isPasswordValid}
                    label="Password"
                  />
                </div>
                <div className="column is-half">
                  <PasswordField
                    name="password_confirm"
                    placeholder="Conferma password"
                    validate={isPasswordValid}
                    label="Conferma password"
                  />
                </div>
              </div>
              <footer>
                <div className="field">
                  <div className="control">
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      className="button is-orange is-large"
                      disabled={submitting || pristine}
                    >
                      Salva
                    </button>
                  </div>
                </div>
              </footer>
            </>
          )}
        />

        {this.state.loading && <Loader />}
      </>
    );
  }
}
